
export default {
  hydra: 'https://api-usgov.webex.com/v1',
  u2c: 'https://u2c.gov.ciscospark.com/u2c/api/v1'
};
